import axios from "axios";
import { api } from "./api_route";

const BASE_URL = `${api}/case-tab-access`;

export const resolveCaseRoleAccessAPI = async ({ organization_id, role_id, caseType }) => {
  try {
    const res = await axios.get(`${BASE_URL}/resolve`, {
      params: { organization_id, role_id, caseType },
    });
    return { success: true, data: res.data?.data || res.data };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || "Failed to resolve access",
      status: error?.response?.status,
    };
  }
};

export const getByIdCaseRoleAccessAPI = async (id) => {
  try {
    const res = await axios.get(`${BASE_URL}/${id}`);
    return { success: true, data: res.data?.data || res.data };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || "Failed to fetch configuration",
    };
  }
};

export const saveCaseRoleAccessAPI = async (payload) => {
  try {
    const res = await axios.post(`${BASE_URL}/save`, payload);
    return { success: true, data: res.data?.data || res.data, message: res.data?.message };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || "Failed to save configuration",
    };
  }
};

export const listCaseRoleAccessAPI = async ({ page = 1, limit = 10, search = "", organization_id } = {}) => {
  try {
    const res = await axios.get(`${BASE_URL}/list`, {
      params: { page, limit, search, organization_id },
    });
    return { success: true, data: res.data?.data || res.data };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || "Failed to list configurations",
    };
  }
};

export const setActiveCaseRoleAccessAPI = async ({ id, isActive }) => {
  try {
    const res = await axios.patch(`${BASE_URL}/${id}/status`, { isActive });
    return { success: true, data: res.data?.data || res.data, message: res.data?.message };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || "Failed to update status",
    };
  }
};

export const deleteCaseRoleAccessAPI = async (id) => {
  try {
    const res = await axios.delete(`${BASE_URL}/${id}`);
    return { success: true, data: res.data?.data || res.data, message: res.data?.message };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || "Failed to delete configuration",
    };
  }
};
